import React from 'react';
import { useAuth } from '../../contexts/AuthContext';

const AccessDeniedPage = () => {
    const { logout, isAdmin } = useAuth();
  return (
    <div style={styles.container}>
      <h1 style={styles.header}>Adgang Nægtet</h1>
      <p style={styles.message}>Du har ikke tilladelse til at se denne side.</p>
      <button onClick={logout}>Gå tilbage til Login</button>
    </div>
  );
};

const styles = {
  container: {
    textAlign: 'center',
    padding: '50px',
  },
  header: {
    fontSize: '2rem',
    color: '#333',
  },
  message: {
    fontSize: '1.2rem',
  }
};

export default AccessDeniedPage;
